// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"324":"b8198c0f","636":"2c4c67b7","693":"ce78fe8b","936":"4f38831f","955":"4f38831f"}[chunkId] + ".chunk.css";
};